// src/composables/useKeyboardDropdown.js
import { ref, nextTick } from "vue";

export function useKeyboardDropdown(options = {}) {
  const activeIndex = ref(-1);

  const { getItems, isOpen, open, close, onSelect } = options;

  function resetActiveIndex() {
    activeIndex.value = -1;
  }

  function moveDown() {
    const items = getItems?.() || [];

    if (!items.length) return;

    if (!isOpen?.()) {
      open?.();
      activeIndex.value = 0;
      return;
    }

    activeIndex.value =
      activeIndex.value < items.length - 1 ? activeIndex.value + 1 : 0;
  }

  function moveUp() {
    const items = getItems?.() || [];

    if (!items.length) return;

    if (!isOpen?.()) {
      open?.();
      activeIndex.value = items.length - 1;
      return;
    }

    activeIndex.value =
      activeIndex.value > 0 ? activeIndex.value - 1 : items.length - 1;
  }

  function selectActive() {
    const items = getItems?.() || [];

    if (activeIndex.value < 0 || activeIndex.value >= items.length) {
      return;
    }

    onSelect?.(items[activeIndex.value]);
    resetActiveIndex();
  }

  function handleKeydown(event) {
    if (event.key === "ArrowDown") {
      event.preventDefault();
      moveDown();
      return;
    }

    if (event.key === "ArrowUp") {
      event.preventDefault();
      moveUp();
      return;
    }

    if (event.key === "Enter") {
      if (isOpen?.() && activeIndex.value >= 0) {
        event.preventDefault();
        selectActive();
      }
      return;
    }

    if (event.key === "Escape") {
      event.preventDefault();
      close?.();
      resetActiveIndex();
    }
  }

  async function scrollActiveItemIntoView(listRef) {
    await nextTick();

    const listEl = listRef?.value;
    if (!listEl) return;

    const activeEl = listEl.querySelector("[data-active='true']");
    if (!activeEl) return;

    activeEl.scrollIntoView({
      block: "nearest",
    });
  }

  return {
    activeIndex,
    resetActiveIndex,
    handleKeydown,
    scrollActiveItemIntoView,
  };
}
